const eighteenYearsFromNow = new Date();

const minimDate = eighteenYearsFromNow.setFullYear(
  eighteenYearsFromNow.getFullYear() - 16
);

export default minimDate;
